import axios from 'axios'

/**
 * @desc Fetches all coupons for specified supplier
 * @param {String} supplierId
 */
export const fetchCoupons = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/coupon-rules`)
    .then((res) => res.data)

/**
 * @desc Add coupon for specified supplier
 * @param {String} supplierId
 */
export const addCoupon = (supplierId, payload) =>
  axios
    .post(`/authenticated/supplier/${supplierId}/coupon-rules`, payload)
    .then((res) => res.data)

/**
 * @desc Update coupon for specified supplier
 * @param {String} supplierId
 * @param {String} couponId
 */
export const updateCoupon = (supplierId, couponId, payload) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/coupon-rules/${couponId}`,
      payload
    )
    .then((res) => res.data)

/**
 * @desc Delete coupon for specified supplier
 * @param {String} supplierId
 * @param {string} couponId
 */
export const deleteCoupon = (supplierId, couponId) =>
  axios
    .delete(`/authenticated/supplier/${supplierId}/coupon-rules/${couponId}`)
    .then((res) => res.data)
